// src/components/ListView/List.js

/* eslint-disable no-useless-computed-key */
import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, Hidden, Grid } from '@material-ui/core'
import Scheduler from '../Scheduler'
import Sort from './Sort'
import {
  List as VirtualizedList,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from 'react-virtualized'
import Empty from './Empty'
import classNames from 'classnames'
import { changeSortBy, updateCount, changeSortOrder } from 'actions/view'
import listSelector from './listSelector'
import UnassignedWarning from 'components/Users/UnassignedWarning'
// import AiInput from './AiInput'
import { isPinnedSelector } from 'selectors/userpin'

export default connect(
  (state, { endpoint, listState, loadStatus, keys }) => {
    return {
      taskModalOpen: state.campaign.addOrEdit?.taskModalOpen,
      viewSelected: state.tasks.viewSelected,
      sort: state.sort[endpoint],
      listSelector: listSelector(state, {
        endpoint,
        listState,
        loadStatus,
        keys,
      }),
      userAssignment: state.sort?.userAssignment,
      count: state.view.count,
      anyUnassignedContacts: Object.keys(state.data?.['contact/a2'] || {})
        .length,
      vr_role: state.auth?.session?.idToken?.payload?.['custom:vr_role'],
      status: state.data?.['account/ap/status'],
      forceUpdateCounter: state.view.forceUpdateCounter,
    }
  },
  dispatch =>
    bindActionCreators(
      { changeSortBy, updateCount, changeSortOrder },
      dispatch,
    ),
)(
  withStyles(theme => {
    return {
      list: {
        borderRadius: 25,
        overflow: 'hidden',
        backgroundColor: '#fff',
        border: '1px solid #adadad',
      },
      window: {
        height: 'calc(100vh - 193px)',
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 161px)',
        },
      },
      windowModal: {
        height: 'calc(100vh - 282px)',
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 185px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 183px)',
        },
      },
      windowUnassigned: {
        height: 'calc(100vh - 296px)',
        ['@media (max-width: 1187px)']: {
          height: 'calc(100vh - 315px)',
        },
        ['@media (max-width: 706px)']: {
          height: 'calc(100vh - 334px)',
        },
        ['@media (max-width: 599.95px)']: {
          height: 'calc(100vh - 278px)',
        },
        ['@media (max-width: 590px)']: {
          height: 'calc(100vh - 298px)',
        },
        ['@media (max-width: 457px)']: {
          height: 'calc(100vh - 318px)',
        },
        ['@media (max-width: 355px)']: {
          height: 'calc(100vh - 367px)',
        },
      },
      windowAssigning: {
        height: 'calc(100vh - 296px)',
        ['@media (max-width: 928px)']: {
          height: 'calc(100vh - 315px)',
        },
        ['@media (max-width: 468px)']: {
          height: 'calc(100vh - 298px)',
        },
      },
      onboardingAndPanels: {
        height: 'calc(100vh - 449px)',
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 380px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 354px)',
        },
      },
      onboarding: {
        height: 'calc(100vh - 281px)',
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 273px)',
        },
      },
      dataPanels: {
        height: 'calc(100vh - 355px)',
        [theme.breakpoints.down('sm')]: {
          height: 'calc(100vh - 286px)',
        },
        [theme.breakpoints.down('xs')]: {
          height: 'calc(100vh - 243px)',
        },
      },
    }
  })(
    class List extends Component {
      constructor() {
        super()
        this.cache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })
        this.largeCache = new CellMeasurerCache({
          fixedWidth: true,
          defaultHeight: 110,
        })
      }

      componentDidMount() {
        if (!this.props.sort) {
          this.props.changeSortBy(
            this.props.endpoint,
            this.props.keys.areFunctions
              ? Object.keys(this.props.keys.sortable)[0]
              : this.props.keys.sortable[0],
          )
        }
        if (this.props.defaultSortOrder) {
          this.props.changeSortOrder(
            this.props.endpoint,
            this.props.defaultSortOrder,
          )
        }
      }

      componentDidUpdate(prevProps) {
        if (
          this.props.sort !== prevProps.sort ||
          this.props.userAssignment !== prevProps.userAssignment ||
          this.props.forceUpdateCounter !== prevProps.forceUpdateCounter
        ) {
          this.cache.clearAll()
          this.largeCache.clearAll()
          if (this?.smallList && this.smallList?.forceUpdateGrid) {
            this.smallList.forceUpdateGrid()
          }
          if (this?.largeList && this.largeList?.forceUpdateGrid) {
            this.largeList.forceUpdateGrid()
          }
        }
        if (this.props.count !== this.list().length) {
          this.props.updateCount(this.list().length)
        }
      }

      list = () => {
        const { ownedBy, listSelector } = this.props

        return ownedBy
          ? listSelector.filter(task => {
              if (
                task.owned_by &&
                task.owned_by.id === ownedBy.id &&
                task.owned_by.type === ownedBy.type
              ) {
                return true
              }
              return false
            })
          : listSelector
      }

      listItem = (size, index) => {
        const { shortLabel, endpoint, history, addOrEditPath, modal, onClick } =
          this.props
        const entityType = shortLabel || endpoint
        const entity = this.list()[index]

        const entityTypeToEndpointMap = {
          template: `${entity?.type || 'email'}/template`,
          form: 'customform',
          group: 'contactgroup',
        }

        const secondary_id = entityTypeToEndpointMap[entityType] || entityType

        const ListItemComponent = require(`./${entityType}`).default
        const ConnectedListItem = connect(
          state => ({
            isPinned: isPinnedSelector(state, secondary_id, entity.id),
          }),
          null,
        )(ListItemComponent)
        // const isPinned = useSelector(state =>
        //   isPinnedSelector(state, entityType, entity.id),
        // )

        const props = {
          [entityType]: entity,
          entityType,
          addOrEditPush: (id, type) =>
            history.push(
              addOrEditPath ? addOrEditPath(id, type) : `/${endpoint}s/${id}`,
            ),
          size,
          // isPinned,
        }

        return {
          component: (
            <ConnectedListItem {...props} modal={modal} onClick={onClick} />
          ),
          entity,
        }
      }

      renderSmallRow = ({ index, isScrolling, key, style, parent }) => {
        const { skeleton, shortLabel, endpoint } = this.props
        const SkeletonComponent = skeleton
          ? require(`./${shortLabel || endpoint}/Skeleton`).default
          : null

        const { component, entity } = this.listItem('small', index)
        const entityId = entity?.id || index

        return (
          <CellMeasurer
            key={`${endpoint}-${entityId}`}
            cache={this.cache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div style={style}>
              {skeleton && isScrolling ? <SkeletonComponent /> : component}
            </div>
          </CellMeasurer>
        )
      }

      renderLargeRow = ({ index, isScrolling, key, style, parent }) => {
        const { skeleton, shortLabel, endpoint } = this.props
        const SkeletonComponent = skeleton
          ? require(`./${shortLabel || endpoint}/Skeleton`).default
          : null

        const { component, entity } = this.listItem('large', index)
        const entityId = entity?.id || index

        return (
          <CellMeasurer
            key={`${endpoint}-${entityId}`}
            cache={this.largeCache}
            parent={parent}
            columnIndex={0}
            rowIndex={index}
          >
            <div style={style}>
              {skeleton && isScrolling ? <SkeletonComponent /> : component}
            </div>
          </CellMeasurer>
        )
      }

      bindSmallListRef = ref => {
        this.smallList = ref
      }

      bindLargeListRef = ref => {
        this.largeList = ref
      }

      render() {
        const {
          classes,
          viewSelected,
          ownedBy,
          campaignPage,
          shortLabel,
          endpoint,
          bulkUpload,
          addOrEditPath,
          addOrEditComponent,
          path,
          helperText,
          guideUrl,
          calendarView,
          heightClass,
          dataPanels,
          history,
          sort,
          keys,
          title,
          customAddPath,
          anyUnassignedContacts,
          vr_role,
          status,
          userAssignment,
          modal,
          listFn,
          taskModalOpen,
        } = this.props

        const list = this.list()

        const calendarComponentRef = createRef()

        let listHeight =
          endpoint === 'contact' &&
          vr_role === 'acctowner' &&
          status?.enabled &&
          anyUnassignedContacts
            ? userAssignment === 'contact/a2'
              ? classes.windowAssigning
              : classes.windowUnassigned
            : classes.window

        if (heightClass) {
          listHeight = heightClass
        } else if (dataPanels) {
          listHeight = classes.dataPanels
        }

        if (modal) {
          listHeight = classes.windowModal
        }

        return (
          <Grid container spacing={16}>
            {/* {endpoint === 'knowledge' && (
              <Grid item xs={12}>
                <AiInput />
              </Grid>
            )} */}
            <Grid item xs={12}>
              {endpoint === 'contact' && !modal && <UnassignedWarning />}
              <Sort
                listFn={listFn}
                endpoint={endpoint}
                sort={sort}
                calendarView={calendarView}
                ref={calendarComponentRef}
                campaignPage={campaignPage}
                sortableKeys={
                  keys.areFunctions ? Object.keys(keys.sortable) : keys.sortable
                }
                nonSortableKeys={keys.nonSortable}
              />
            </Grid>
            <Grid item xs={12}>
              {viewSelected === 'list' || taskModalOpen ? (
                list.length ? (
                  <div className={classNames(listHeight, classes.list)}>
                    <Hidden mdUp>
                      <AutoSizer>
                        {({ width, height }) => (
                          <VirtualizedList
                            ref={this.bindSmallListRef}
                            width={width}
                            height={height}
                            deferredMeasurementCache={this.cache}
                            rowHeight={this.cache.rowHeight}
                            rowRenderer={this.renderSmallRow}
                            rowCount={list.length}
                            overscanRowCount={10}
                            rowKey={index => {
                              const entity = this.list()[index]
                              return `${this.props.endpoint}-${
                                entity?.id || index
                              }`
                            }}
                          />
                        )}
                      </AutoSizer>
                    </Hidden>
                    <Hidden smDown>
                      <AutoSizer>
                        {({ width, height }) => (
                          <VirtualizedList
                            ref={this.bindLargeListRef}
                            width={width}
                            height={height}
                            deferredMeasurementCache={this.largeCache}
                            rowHeight={this.largeCache.rowHeight}
                            rowRenderer={this.renderLargeRow}
                            rowCount={list.length}
                            overscanRowCount={10}
                            rowKey={index => {
                              const entity = this.list()[index]
                              return `${this.props.endpoint}-${
                                entity?.id || index
                              }`
                            }}
                          />
                        )}
                      </AutoSizer>
                    </Hidden>
                  </div>
                ) : (
                  <Empty
                    guideUrl={guideUrl}
                    path={path}
                    addOrEditPath={
                      addOrEditPath ? addOrEditPath : id => `${endpoint}s/${id}`
                    }
                    customAddPath={customAddPath}
                    addOrEditComponent={addOrEditComponent}
                    bulkUpload={bulkUpload}
                    shortLabel={shortLabel}
                    endpoint={endpoint}
                    helperText={helperText}
                    history={history}
                    title={title}
                  />
                )
              ) : (
                <Scheduler ref={calendarComponentRef} ownedBy={ownedBy} />
              )}
            </Grid>
          </Grid>
        )
      }
    },
  ),
)
